import { useState, useRef, useEffect } from "react"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { signOut } from "firebase/auth"
import { auth } from "../../services/firebase"
import { useAuth } from "../../context/AuthContext"
import logo from "../../assets/LOGO_LT_H.png"
import "./Header.css"

// ── Helpers puntos ──
const CANJE = [
  { puntos:50,  descuento:10  },
  { puntos:100, descuento:25  },
  { puntos:350, descuento:100 },
]
function calcularDescuento(puntos) {
  let desc = 0, rest = puntos
  ;[...CANJE].sort((a,b)=>b.puntos-a.puntos).forEach(c => {
    const v = Math.floor(rest/c.puntos); desc += v*c.descuento; rest -= v*c.puntos
  })
  return desc
}
function ptsCliente(c) {
  if (!c) return 0
  return (c.puntos_aporte||0)+(c.puntos_feedback||0)+(c.puntos_referidos||0)
        +(c.puntos_compra_ref||0)+(c.puntos_cumpleanos||0)-(c.puntos_usados||0)
}

// ── Badge de puntos (desktop) ──
function BadgePuntos({ clienteData }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)
  const puntos    = ptsCliente(clienteData)
  const descuento = calcularDescuento(puntos)

  useEffect(() => {
    const handle = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener("mousedown", handle)
    return () => document.removeEventListener("mousedown", handle)
  }, [])

  return (
    <div className="header__pts-wrap" ref={ref}>
      <button
        className={"header__pts-badge" + (open ? " open" : "") + (puntos > 0 ? " tiene-puntos" : "")}
        onClick={() => setOpen(p => !p)}
        title="Tus puntos Low Travel"
      >
        <span className="header__pts-star">⭐</span>
        <span className="header__pts-val">{puntos > 0 ? `${puntos} pts` : "0 pts"}</span>
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
          style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)", transition:"transform 0.2s", flexShrink:0 }}>
          <path d="M6 9l6 6 6-6"/>
        </svg>
      </button>

      {open && (
        <div className="header__pts-panel">
          <div className="header__pts-panel-head">
            <div className="header__pts-panel-titulo">Puntos Low Travel</div>
            {puntos > 0 ? (
              <div className="header__pts-panel-total">
                <span className="header__pts-panel-num">{puntos}</span>
                <span className="header__pts-panel-label">puntos disponibles</span>
              </div>
            ) : (
              <div className="header__pts-panel-vacio">
                Aún no acumulaste puntos.<br/>¡El primer viaje ya te da puntos!
              </div>
            )}
          </div>

          {puntos > 0 && (
            <div className="header__pts-panel-desc">
              <span>💰 Descuento disponible:</span>
              <strong>${descuento} USD</strong>
            </div>
          )}

          <div className="header__pts-panel-tabla">
            <div className="header__pts-panel-tabla-titulo">Tabla de canje</div>
            {CANJE.map(c => (
              <div key={c.puntos} className={"header__pts-panel-fila" + (puntos >= c.puntos ? " alcanzado" : "")}>
                <span>⭐ {c.puntos} pts</span>
                <span className="header__pts-panel-flecha">→</span>
                <span className="header__pts-panel-valor">${c.descuento} USD</span>
                {puntos >= c.puntos && <span className="header__pts-panel-ok">✓</span>}
              </div>
            ))}
          </div>

          <div className="header__pts-panel-footer">
            <Link to="/propuestas" onClick={() => setOpen(false)} className="header__pts-panel-link">
              Ver propuestas y aplicar descuento →
            </Link>
          </div>
        </div>
      )}
    </div>
  )
}

// ── Bottom Tab Bar (solo mobile) ──
function BottomTabBar({ user, userData, clienteData, onLogout }) {
  const location = useLocation()
  const puntos   = ptsCliente(clienteData)
  const esAdmin  = !!user && userData?.es_admin
  const esCliente= !!user && !userData?.es_admin
  const path     = location.pathname

  const isActive = (to) =>
    to === "/" ? path === "/" : path.startsWith(to)

  return (
    <nav className="bottom-tab-bar">

      {/* Inicio */}
      <Link to="/" className={"bottom-tab" + (isActive("/") ? " active" : "")}>
        <svg className="bottom-tab__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
        <span>Inicio</span>
      </Link>

      {/* Propuestas */}
      <Link to="/propuestas" className={"bottom-tab" + (isActive("/propuestas") ? " active" : "")}>
        <svg className="bottom-tab__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 2L11 13"/>
          <path d="M22 2L15 22 11 13 2 9l20-7z"/>
        </svg>
        <span>Propuestas</span>
      </Link>

      {/* Consultar */}
      <Link to="/consulta" className={"bottom-tab" + (isActive("/consulta") ? " active" : "")}>
        <svg className="bottom-tab__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
        <span>Consultar</span>
      </Link>

      {/* Cotizador (vendedores y admins) */}
      {!!user && (userData?.es_admin || userData?.es_vendedor) && (
        <Link to="/cotizador" className={"bottom-tab" + (isActive("/cotizador") ? " active" : "")}>
          <svg className="bottom-tab__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="3" width="20" height="14" rx="2"/>
            <path d="M8 21h8M12 17v4"/>
            <path d="M7 8h2M7 12h2M12 8h5M12 12h5"/>
          </svg>
          <span>Cotizador</span>
        </Link>
      )}

      {/* Mi cuenta / Entrar / Admin */}
      {esAdmin && (
        <Link to="/admin" className={"bottom-tab" + (isActive("/admin") ? " active" : "")}>
          <svg className="bottom-tab__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="8" r="4"/>
            <path d="M20 21a8 8 0 10-16 0"/>
          </svg>
          <span>Admin</span>
        </Link>
      )}

      {esCliente && (
        <Link to="/dashboard" className={"bottom-tab" + (isActive("/dashboard") ? " active" : "")}>
          <svg className="bottom-tab__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="8" r="4"/>
            <path d="M20 21a8 8 0 10-16 0"/>
          </svg>
          {puntos > 0 && <span className="bottom-tab__badge">{puntos}</span>}
          <span>Mi cuenta</span>
        </Link>
      )}

      {!user && (
        <Link to="/login" className={"bottom-tab" + (isActive("/login") || isActive("/register") ? " active" : "")}>
          <svg className="bottom-tab__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4"/>
            <polyline points="10 17 15 12 10 7"/>
            <line x1="15" y1="12" x2="3" y2="12"/>
          </svg>
          <span>Entrar</span>
        </Link>
      )}

    </nav>
  )
}

// ── Header principal ──
export default function Header() {
  const { user, userData, clienteData } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const esAdmin  = location.pathname.startsWith("/admin")

  async function handleLogout() {
    await signOut(auth)
    navigate("/")
  }

  return (
    <>
      <header className="header header--dark">
        <div className="header__inner container">

          <Link to="/" className="header__logo-wrap">
            <img src={logo} alt="Low Travel" className="header__logo-img" />
            <span className="header__vendedor">
              <span className="header__vendedor-icono">✈️</span>
              Asesor: <strong>Sergio</strong>
            </span>
          </Link>

          {/* ── Nav desktop — sin cambios ── */}
          <nav className="header__nav">
            <Link to="/" className="header__link">Inicio</Link>
            <Link to="/propuestas" className="header__link">Propuestas</Link>
            <Link to="/consulta" className="header__link">Consultar</Link>

            {!user && (
              <>
                <Link to="/login" className="header__btn header__btn--outline">Iniciar sesión</Link>
                <Link to="/register" className="header__btn header__btn--primary">Registrarme</Link>
              </>
            )}

            {user && !userData?.es_admin && !userData?.es_vendedor && (
              <>
                <BadgePuntos clienteData={clienteData} />
                <Link to="/dashboard" className="header__link">Mi cuenta</Link>
                <button onClick={handleLogout} className="header__btn header__btn--outline">Salir</button>
              </>
            )}

            {user && userData?.es_vendedor && !userData?.es_admin && (
              <>
                <Link to="/cotizador" className="header__link">Cotizador</Link>
                <Link to="/generador" className="header__link">Generador</Link>
                <button onClick={handleLogout} className="header__btn header__btn--outline">Salir</button>
              </>
            )}

            {user && userData?.es_admin && (
              <>
                <Link to="/cotizador" className="header__link">Cotizador</Link>
                <Link to="/generador" className="header__link">Generador</Link>
                <Link to="/admin" className="header__link header__link--admin">Panel Admin</Link>
                <button onClick={handleLogout} className="header__btn header__btn--outline">Salir</button>
              </>
            )}
          </nav>

        </div>
      </header>

      {/* ── Bottom Tab Bar — solo mobile vía CSS ── */}
      <BottomTabBar
        user={user}
        userData={userData}
        clienteData={clienteData}
        onLogout={handleLogout}
      />
    </>
  )
}